/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PrivateSlotType {
  FIXED = 'fixed',
  INTERVAL = 'interval',
}
